<template>
  <div
    v-if="character"
    class="text-center summary-section"
  >
    <p class="bb-hdg mt-2 mb-3">Abilities</p>
    <div class="row mb-2"></div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="displayCharacter?.ca_cur"
            id="ca_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="ca_cur"
            >CA</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="displayCharacter?.cr_cur"
            id="cr_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="cr_cur"
            >CR</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center"
            :value="displayCharacter?.sr_cur"
            id="sr_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="sr_cur"
            >SR</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center text-uppercase"
            :value="formatDamageMod(displayCharacter?.damage_mod_melee_cur)"
            id="dam_mod_melee_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="dam_mod_melee_cur"
            >Dam Mod Melee</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center text-uppercase"
            :value="formatDamageMod(displayCharacter?.damage_mod_ranged_cur)"
            id="dam_mod_ranged_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="dam_mod_ranged_cur"
            >Dam Mod Rng</label
          >
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center text-uppercase"
            :value="formatMoveValue(displayCharacter?.move_cur)"
            id="move_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="move_cur"
            >Move</label
          >
        </div>
      </div>
    </div>
    <div
      v-if="displayCharacter?.move_fly_cur > 0"
      class="row mb-2"
    >
      <div class="form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-center text-uppercase"
            :value="formatMoveValue(displayCharacter?.move_fly_cur)"
            id="move_fly_cur"
            disabled
          />
          <label
            class="readonly bb-float-label optional"
            for="move_fly_cur"
            >Fly</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buildDisplayedAbilitySnapshot from '../helpers/buildDisplayedAbilitySnapshot'

export default {
  name: 'SheetSummaryAbilities',
  props: {
    character: {
      type: Object,
      required: true,
    },
  },
  watch: {
    character: {
      handler: function (newCharacter) {
        if (!newCharacter) {
          return
        }
        // console.log(
        //   'SheetSummaryAbilities - character prop changed chars:',
        //   newCharacter.characteristics,
        // )
        // console.log('SheetSummaryAbilities - sr_base :', newCharacter.sr_base)
        // console.log('SheetSummaryAbilities - sr_cur :', newCharacter.sr_cur)
        // console.log(
        //   'SheetSummaryAbilities - sr_adjs_tot :',
        //   newCharacter.sr_adjs_tot,
        // )
      },
    },
  },
  computed: {
    displayCharacter() {
      return buildDisplayedAbilitySnapshot(this.character)
    },
  },
  methods: {
    formatMoveValue(value) {
      const numericValue = Number(value)

      if (Number.isNaN(numericValue)) {
        return value
      }

      return Number.isInteger(numericValue)
        ? numericValue
        : numericValue.toFixed(1)
    },
    formatDamageMod(value) {
      const numericValue = Number(value)

      if (Number.isNaN(numericValue)) {
        return value
      }

      if (numericValue > 0) {
        return `+${numericValue}`
      }

      return `${numericValue}`
    },
  },
}
</script>

<style scoped>
.summary-section {
  min-width: 0;
  width: 100%;
}
</style>
